import { CommonModule } from "@angular/common";
import { Component, ElementRef, inject, input, TemplateRef, viewChild } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { ModalType } from "@core/enums/ModalType.enum";
import { ModalService } from "@core/services/modal.service";

@Component({
    selector: 'app-information-prompt',
    templateUrl: './modal.component.html',
    standalone: true,
    styles: [''],
    imports: [
      CommonModule,
      ReactiveFormsModule,
    ]
  })
  export class ModalComponent {
    modalService = inject(ModalService)
    readonly ModalTypes = ModalType;
    messageType = input.required<ModalType | undefined>();
    message = input.required<TemplateRef<any> | null>();

    okmodalbutton = viewChild<ElementRef>('okmodalbutton');

    ngAfterViewInit(): void {
      this.okmodalbutton()?.nativeElement.focus();
    }
  }
